import {
  ApplicationRef,
  type ComponentRef,
  createComponent,
  type ElementRef,
  type EnvironmentInjector,
  inject,
  Injectable,
  type Injector,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DomUtilService {
  private appRef = inject(ApplicationRef);

  appendComponentToBody(
    componentType: any,
    environmentInjector: EnvironmentInjector, // required to use createComponent
    elementInjector: Injector, // required to get provided services from component
    inputs: { [key: string]: any },
    positioningElementRef: ElementRef,
    minWidth?: number,
    allowMove?: boolean,
  ): ComponentRef<any> {
    // Create a component reference from the component
    const createdComponent = createComponent(componentType, {
      environmentInjector,
      elementInjector,
    });

    if (inputs) {
      Object.keys(inputs).forEach((key) => {
        createdComponent.setInput(key, inputs[key]);
      });
    }

    document.body.appendChild(createdComponent.location.nativeElement);

    this.appRef.attachView(createdComponent.hostView);

    // style
    this.positionBelowElement(createdComponent.location.nativeElement, positioningElementRef, minWidth, allowMove);

    return createdComponent;
  }

  detachComponentFromBody(component: ComponentRef<any>) {
    this.appRef.detachView(component.hostView);
    component.destroy();
  }

  private positionBelowElement(
    domElem: HTMLElement,
    positioningElementRef: ElementRef,
    minWidth = 0,
    allowMove = true,
  ) {
    if (!positioningElementRef || !positioningElementRef.nativeElement) {
      return;
    }

    // determine positioning
    const rect = positioningElementRef.nativeElement.getBoundingClientRect();

    const width = Math.max(rect.width, minWidth);
    const positioningStyle = this.getPositionCss(rect.left, rect.bottom, width);

    if (allowMove) {
      // position above input field if outside screen
      setTimeout(() => {
        const needToMoveUp = domElem.scrollHeight !== domElem.offsetHeight;

        if (needToMoveUp) {
          const moveDistance = domElem.scrollHeight - domElem.offsetHeight;
          let top = rect.top - moveDistance;
          top = top < 60 ? 60 : top; // position below the top navigation bar

          domElem.style.cssText = this.getPositionCss(rect.left, top, width);
        }
      }, 10);
    }

    //set styling
    domElem.style.cssText = positioningStyle;
  }

  private getPositionCss(left: number, top: number, width: number) {
    const isSmallScreen = window.outerWidth < 768;
    if (isSmallScreen) {
      return `
      position: absolute;
      top: ${top}px;
    `;
    }

    return `
      position: absolute;
      left: ${left}px;
      top: ${top}px;
      width: ${width}px;
    `;
  }
}
